import _objectWithoutProperties from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "className", "id", "placeholder", "style", "whenCreated"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { CONTEXT_VERSION, LeafletProvider } from '@react-leaflet/core';
import { Map as LeafletMap } from 'leaflet';
import React, { useEffect, useMemo, useRef, useState } from 'react';
export function useMapElement(mapRef, props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    map = _useState2[0],
    setMap = _useState2[1];
  useEffect(function () {
    if (mapRef.current !== null && map === null) {
      var instance = new LeafletMap(mapRef.current, props);
      if (props.center != null && props.zoom != null) {
        instance.setView(props.center, props.zoom);
      } else if (props.bounds != null) {
        instance.fitBounds(props.bounds, props.boundsOptions);
      }
      if (props.whenReady != null) {
        instance.whenReady(props.whenReady);
      }
      setMap(instance);
    }
  }, [mapRef, map, props]);
  return map;
}
export function MapContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    placeholder = _ref.placeholder,
    style = _ref.style,
    whenCreated = _ref.whenCreated,
    options = _objectWithoutProperties(_ref, _excluded);
  var mapRef = useRef(null);
  var map = useMapElement(mapRef, options);
  var createdRef = useRef(false);
  useEffect(function () {
    if (map != null && createdRef.current === false && whenCreated != null) {
      createdRef.current = true;
      whenCreated(map);
    }
  }, [map, whenCreated]);
  useEffect(function () {
    return function () {
      map == null ? void 0 : map.remove();
    };
  }, [map]);
  var _useState3 = useState({
      className: className,
      id: id,
      style: style
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    props = _useState4[0];
  var context = useMemo(function () {
    return map ? {
      __version: CONTEXT_VERSION,
      map: map
    } : null;
  }, [map]);
  var contents = context ? /*#__PURE__*/React.createElement(LeafletProvider, {
    value: context
  }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: mapRef
  }), contents);
}